import { COLORS } from '@/styles/colorTheme';
import { ChartNoAxesCombined } from 'lucide-react';
const HomeIcon = ({ state = 'mouseup' }) => {
  let color = COLORS.Text400;
  if (state === 'mousedown') color = '#fff';

  return (
    <>
      <ChartNoAxesCombined size={22} color={color} strokeWidth={1.5} />
    </>
  );
};

export default HomeIcon;
